"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanel = exports.TabPanelGroup = exports.TabPanelContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n\n  width: calc(100% / ", ");\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: ", "%;\n  display: flex;\n\n  will-change: transform;\n  transform: translateX(", "%);\n  transition: transform 350ms ease-in-out;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow-x: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabPanelContainer = _styledComponents.default.section(_templateObject());

exports.TabPanelContainer = TabPanelContainer;

var TabPanelGroup = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var children = _ref.children;
  return children.length * 100;
}, function (_ref2) {
  var index = _ref2.index,
      children = _ref2.children;
  return -100 * index / children.length;
});

exports.TabPanelGroup = TabPanelGroup;

var TabPanel = _styledComponents.default.div.attrs(function () {
  return {
    className: 'p-4'
  };
})(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(4);
}, function (_ref4) {
  var numberOfChildren = _ref4.numberOfChildren;
  return numberOfChildren || 1;
});

exports.TabPanel = TabPanel;